<template>
	<section class="student-place-exercise-sheet-container main-">
		<div class="title-container">
			<h1>Questions Flash</h1>
		</div>

		<div class="qcms-container">
			<key-question-container 
				v-for="key in activities"
				:key="key.id"
				:id="key.id"
				:activities="key.activities"
				:name="key.name"
			/>
		</div>
	</section>
</template>

<script>
import { decrypt, authenticatedStudentApiFetch } from '../../utils/utils'
import KeyQuestionContainer from './KeyQuestionContainer.vue'
import { filteredSharedResourcesService } from '../../services/sharedResourcesService'
import { getActivityByIdService } from '../../services/activitiesService'
export default {
	components: { KeyQuestionContainer },
	data() {
		return {
			flashQuestions: [],
			classId: null,
			activities: []
		}
	},
	methods: {
		async qcmForTeacher(){
			const filter = `class_id=${this.classId}&visible_for_student=true`
			const sharedResource = await filteredSharedResourcesService(filter)
			console.log(sharedResource)
			for(const resource of sharedResource){
				if(resource.activity_id){
					const res  = await getActivityByIdService(resource.activity_id)
					console.log(res)
					this.activities.push(res)
				}
			}
		},
		async getLessonsForStudent() {
			const sharedResource = await authenticatedStudentApiFetch('/shared-resources-student/')
				.then(res => res.json())

			for(const resource of sharedResource){
				if(resource.activity_id){
					const res = await authenticatedStudentApiFetch( `/activities/${resource.activity_id}/`, {method: 'GET'})
						.then(res => res.json())
					this.activities.push(res)
				}
			}
		},
		async getLessons() {
			if(localStorage.getItem('userId') !== null){
				this.qcmForTeacher()
				return
			}
			this.getLessonsForStudent()
		}
	},

	created() {
		this.classId = decrypt(this.$route.params.classId)
		this.getLessons()

	},
}
</script>

<style>
</style>
